import axios from 'axios';
import { API_BASE_URL } from './config';

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

export const fetchReports = async ({ lang, year } = {}) => {
  try {
    const response = await apiClient.get('/reports/', {
      params: {
        lang,
        year
      }
    });
    return response.data.results || response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch reports');
  }
};

export const fetchReportDetails = async (id, lang) => {
  try {
    const response = await apiClient.get(`/reports/${id}/`, {
      params: { lang }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to fetch report details');
  }
};